export const isTheDomainAWhitelabel = (domain: string) => {
  for (const whitelabelDomain of whitelabelsDomains) {
    if (domain.includes(whitelabelDomain)) {
      return true
    }
  }
  return false
}

const whitelabelsDomains: string[] = [
  'mobilesyrup.planhub.ca',
  'ratehub.planhub.ca',
  'francoischarron.planhub.ca',
  'protegezvous.planhub.ca',
  'lactualite.planhub.ca',
  'redflagdeals.planhub.ca',
]
